import Home from '../views/Home.vue'

const routes = [
	// {
	// 	path: '/',
	// 	name: 'Home',
	// 	component: Home
	// },
	// {
	// 	path: '/about',
	// 	name: 'About',
	// 	// 路由级别的代码分割
	// 	// 这会为这个路由生成一个单独的块 (about.[hash].js)
	// 	component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
	// },

	{
		path: '/',
		redirect: '/index' // 访问根路径时自动跳转到 /contact
	},
	{
		path: '/index',
		name: 'HomeIndex',
		component: () => import( /* webpackChunkName: "contact" */ '../views/Index.vue')
	},
	// {
	// 	path: '/founder',
	// 	name: 'Founder',
	// 	component: () => import( /* webpackChunkName: "founder" */ '../views/Founder.vue')
	// },
	// {
	// 	path: '/projects',
	// 	name: 'Projects',
	// 	component: () => import( /* webpackChunkName: "projects" */ '../views/Projects.vue')
	// },
	// {
	// 	path: '/materials',
	// 	name: 'Materials',
	// 	component: () => import( /* webpackChunkName: "materials" */ '../views/Materials.vue')
	// },
	// {
	// 	path: '/stories',
	// 	name: 'Stories',
	// 	component: () => import( /* webpackChunkName: "stories" */ '../views/Stories.vue')
	// }
]

export default routes